import CardModalNameEdit from './CardModalNameEdit';

export default CardModalNameEdit;
